import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    currencyInputContainer: {
      display: 'flex',
      width: '229px',
      height: '36px',
      padding: '0px 45px 0px 0',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '8px',
      border: '1px solid #DBDBDB',
      position: 'relative',
      boxSizing: 'border-box',
    },
    currencyInputError: {
      border: '1px solid #D93636',
      borderRadius: '8px',
    },
    currencySymbolBox: {
      display: 'flex',
      height: '36px',
      borderRight: '1px solid #DBDBDB',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: '12px',
      paddingRight: '10px',
      color: '#1A1919',
      fontSize: '16px',
      fontWeight: 400,
      flexShrink: 0,
    },
    currencySymbolBoxError: {
      borderRight: '1px solid #D93636',
    },
    currencyInput: {
      flex: 1,
      '& .MuiInput-input': {
        fontSize: '16px',
        padding: '0 0px',
        border: 'none',
        outline: 'none',
        height: '100%',
        '&::placeholder': {
          color: '#9E9E9E',
          opacity: 1,
        },
        '&:focus::placeholder': {
          opacity: 0,
        },
      },
      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
    },
  }),
  { name: 'CurrencyInput' },
);

export default useStyles;
